import moment from "moment";
import { isFirstDateGreaterThanSecond } from "../../constants";

export const initialState = {
  seriesEmbargoDate: moment(),
  seriesTimePicker: "",
  centersEmbargo: {
    centers: "",
    qual: "",
    date: moment(),
    time: "",
  },
  qualEmbargo: {
    qual: "",
    date: moment(),
    time: "",
  },
  centerRangeEmbargo: {
    from: "",
    to: "",
    qual: "",
    date: moment(),
    time: "",
  },
};

export function embargoReducer(state, action) {
  switch (action.type) {
    case "SET_SERIES_DATA": {
      const { date, time, initialLoad } = action.payload;

      const updateEmbargo = embargo => ({
        ...embargo,
        ...(date && { date: moment(date, "DD-MM-YYYY") }),
        ...(time && { time }),
      });

      return {
        ...state,
        ...(date && { seriesEmbargoDate: moment(date, "DD-MM-YYYY") }),
        ...(time && { seriesTimePicker: time }),
        ...(initialLoad && {
          centersEmbargo: updateEmbargo(state.centersEmbargo),
          qualEmbargo: updateEmbargo(state.qualEmbargo),
          centerRangeEmbargo: updateEmbargo(state.centerRangeEmbargo),
        }),
      };
    }

    case "UPDATE_FIELD": {
      const { section, field, value } = action.payload;
      return {
        ...state,
        [section]: {
          ...state[section],
          [field]: field === "date" ? moment(value, "DD-MM-YYYY") : value,
        },
      };
    }

    case "RESET_ALL":
        return initialState;
    default:
      return state;
  }
}

const isEmpty = value => {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    (moment.isMoment(value) && !value.isValid())
  );
};

const isValidCentersInput = input => {
  const regex = /^[A-Z0-9]{5}(,\s*[A-Z0-9]{5})*$/;
  return regex.test(input.trim());
};

export const validateFields = (type, state, prevDate) => {
  let errors = [];

  switch (type) {
    case "centersEmbargo": {
      const { centers, qual, date, time } = state.centersEmbargo;

      const centersEmbargoDateTime = `${date.format("DD-MM-YYYY")} ${time}`;

      if (isEmpty(centers)) errors.push("Centers field is required.");
      if (isEmpty(qual)) errors.push("Qualification is required.");
      if (isEmpty(date)) errors.push("Embargo date is required.");
      if (isEmpty(time)) errors.push("Embargo time is required.");

      if (!isEmpty(centers) && !isValidCentersInput(centers)) {
        errors.push(
          "Centers input format or length is invalid"
        );
      }

      if (
        !isEmpty(date) &&
        !isEmpty(time) &&
        !isFirstDateGreaterThanSecond(centersEmbargoDateTime, prevDate)
      ) {
        errors.push(
          "Centers embargo date and time must be after the Report Maker Series result release date and time."
        );
      }
      break;
    }

    case "qualEmbargo": {
      const { qual, date, time } = state.qualEmbargo;

      const qualEmbargoDateTime = `${date.format("DD-MM-YYYY")} ${time}`;

      if (isEmpty(qual)) errors.push("Qualification is required.");
      if (isEmpty(date)) errors.push("Embargo date is required.");
      if (isEmpty(time)) errors.push("Embargo time is required.");

      if (
        !isEmpty(date) &&
        !isEmpty(time) &&
        !isFirstDateGreaterThanSecond(qualEmbargoDateTime, prevDate)
      ) {
        errors.push(
          "Qualification embargo date and time must be after the Report Maker Series result release date and time."
        );
      }
      break;
    }
    
    case "centerRangeEmbargo": {
      const { from, to, qual, date, time } = state.centerRangeEmbargo;

      const centerRangeEmbargoDateTime = `${date.format("DD-MM-YYYY")} ${time}`;

      if (isEmpty(from)) errors.push("From center is required.");
      if (isEmpty(to)) errors.push("To center is required.");
      if (isEmpty(qual)) errors.push("Qualification is required.");
      if (isEmpty(date)) errors.push("Embargo date is required.");
      if (isEmpty(time)) errors.push("Embargo time is required.");

      if (!isEmpty(from) && from.trim().length !== 5) {
        errors.push(
          "From center number must be exactly 5 characters (e.g., US001)."
        );
      }
      if (!isEmpty(to) && to.trim().length !== 5) {
        errors.push(
          "To center number must be exactly 5 characters (e.g., US005)."
        );
      }
      if (!isEmpty(from) && !isEmpty(to) && from.substring(0, 2) !== to.substring(0, 2)) {
        errors.push(
          "Invalid center range. Please provide the correct center range."
        );
      }
      if (
        !isEmpty(date) &&
        !isEmpty(time) &&
        !isFirstDateGreaterThanSecond(centerRangeEmbargoDateTime, prevDate)
      ) {
        errors.push(
          "Center range embargo date and time must be after the Report Maker Series result release date and time."
        );
      }
      break;
    }

    default:
      errors.push("Unknown embargo type.");
  }

  if (errors.length > 0) {
    return { isValid: false, errors };
  }

  return { isValid: true, errors: [] };
};